import { Text } from "components/Typography/text.styled";
import { Color } from "config/colors";
import { FontSize } from "config/font";

type DividerWithTextProps = {
  text: string;
};

export const DividerWithText = ({ text }: DividerWithTextProps) => {
  return (
    <div style={{ display: "flex", alignItems: "center", margin: "1rem 0" }}>
      <div
        style={{ flex: 1, borderBottom: `0.2px solid ${Color.LightGrey03}` }}
      />
      <Text style={{ margin: "0 8px" }} fontSize={FontSize.Standard}>
        {text}
      </Text>
      <div
        style={{ flex: 1, borderBottom: `0.2px solid ${Color.LightGrey03}` }}
      />
    </div>
  );
};
